module.exports = __webpack_public_path__ + "img/beian.58f55c5c.png";